import { v4 } from 'uuid';
import { z } from 'zod';

export type Uuid<T = unknown> = string & {
  _uuidBrand: 'Uuid';
  _type: T;
};
export const ZodUuid = <T>() =>
  z
    .string()
    .uuid()
    .transform((u) => u as Uuid<T>);

export const newUuid = <T>(): Uuid<T> => {
  return v4() as Uuid<T>;
};

export const isUuid = <T>(v: unknown): v is Uuid<T> => {
  const result = ZodUuid<T>().safeParse(v);

  return result.success;
};

export type ExternalId<T extends string> = string & {
  _externalIdBrand: T;
};
